/**
 * J4K Reveal Header — Nike-style "reveal on scroll up"
 *
 * Nike's secret: the title bar (H1 + Hide Filters + Sort By) is INSIDE
 * the same sticky header wrapper as the navbar. They're ONE element,
 * so there's never a gap when the header transforms.
 *
 * We replicate this by appending a mirror of the collection header
 * controls inside the site header. When the user scrolls past the
 * original collection header, the mirror activates. Both elements
 * share the same transform — zero gap, guaranteed.
 */
(function () {
  'use strict';

  var header = document.getElementById('SiteHeader');
  if (!header || header.getAttribute('data-reveal') !== 'true') return;

  var override = (header.getAttribute('data-reveal-override') || '').toLowerCase().trim();
  if (override === 'disable') return;

  var shouldReveal = false;
  if (override === 'enable') {
    shouldReveal = true;
  } else {
    var body = document.body;
    if (body.classList.contains('template-index')) {
      shouldReveal = header.getAttribute('data-reveal-home') === 'true';
    } else if (body.classList.contains('template-collection')) {
      shouldReveal = header.getAttribute('data-reveal-collection') === 'true';
    } else if (body.classList.contains('template-product')) {
      shouldReveal = header.getAttribute('data-reveal-product') === 'true';
    } else if (body.classList.contains('template-blog') || body.classList.contains('template-article')) {
      shouldReveal = header.getAttribute('data-reveal-blog') === 'true';
    } else {
      shouldReveal = header.getAttribute('data-reveal-pages') === 'true';
    }
  }

  if (!shouldReveal) return;

  var lastScrollY = 0;
  var ticking = false;
  var isHidden = false;
  var SCROLL_THRESHOLD = 5;
  var TRANSITION_DURATION = '0.15s';
  var collectionHeader = document.querySelector('.j4k-collection__header');
  var sidebar = document.querySelector('.j4k-collection__sidebar');

  // Build mirror bar inside the header (like Nike)
  var mirrorBar = null;
  var collectionHeaderBottom = 0;
  var lastHeaderHeight = 0;

  if (collectionHeader) {
    // Measure where the original collection header sits
    collectionHeaderBottom = collectionHeader.getBoundingClientRect().bottom + window.scrollY;

    // Create mirror bar
    mirrorBar = document.createElement('div');
    mirrorBar.className = 'j4k-reveal-mirror';
    mirrorBar.innerHTML = collectionHeader.innerHTML;
    header.appendChild(mirrorBar);

    // Wire up filter toggle click
    var mirrorFilterBtn = mirrorBar.querySelector('.j4k-collection__filter-toggle');
    var origFilterBtn = collectionHeader.querySelector('.j4k-collection__filter-toggle');
    if (mirrorFilterBtn && origFilterBtn) {
      mirrorFilterBtn.addEventListener('click', function (e) {
        e.preventDefault();
        origFilterBtn.click();
        // Sync button text
        setTimeout(function () {
          mirrorFilterBtn.innerHTML = origFilterBtn.innerHTML;
        }, 50);
      });
    }

    // Wire up sort dropdown
    var mirrorSort = mirrorBar.querySelector('.j4k-collection__sort');
    var origSort = collectionHeader.querySelector('.j4k-collection__sort');
    if (mirrorSort && origSort) {
      mirrorSort.addEventListener('change', function () {
        origSort.value = mirrorSort.value;
        origSort.dispatchEvent(new Event('change', { bubbles: true }));
      });
      // Sync sort value from original to mirror
      origSort.addEventListener('change', function () {
        mirrorSort.value = origSort.value;
      });
    }
  }

  // Inject styles
  var style = document.createElement('style');
  style.textContent = [
    '/* Reveal header — single transform for both navbar + mirror bar */',
    '.site-header[data-reveal="true"] {',
    '  transition: transform ' + TRANSITION_DURATION + ' ease;',
    '}',
    '.site-header[data-reveal="true"].j4k-header-hidden {',
    '  transform: translateY(-100%);',
    '}',
    '',
    '/* Mirror bar (inside header, moves with it) */',
    '.j4k-reveal-mirror {',
    '  display: none;',
    '  padding: 8px 48px;',
    '  align-items: center;',
    '  justify-content: space-between;',
    '  background: #fff;',
    '  border-top: none;',
    '}',
    '.j4k-reveal-mirror.is-visible {',
    '  display: flex;',
    '}',
    '',
    '/* Keep original collection header in place — no transform/top changes */',
    '.j4k-collection__header {',
    '  position: sticky;',
    '  top: 0;',
    '  z-index: 10;',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  // Title scale: track the collection header's natural position
  // Title stays small (is-stuck) until user scrolls all the way back to top
  // Use the header's offset (announcement bar height) so title only goes big
  // when the collection header is fully visible below the navbar
  var stickyTrigger = collectionHeader ? Math.max(0, collectionHeader.offsetTop - header.offsetHeight) : 0;

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  function update() {
    ticking = false;

    var scrollY = window.scrollY;
    var delta = scrollY - lastScrollY;
    var headerHeight = header.offsetHeight;

    // Title scale: small when scrolled past collection header, full size only at very top
    if (collectionHeader) {
      if (scrollY > stickyTrigger) {
        collectionHeader.classList.add('is-stuck');
      } else {
        collectionHeader.classList.remove('is-stuck');
      }
    }

    // Show/hide mirror bar based on scroll position past original collection header
    if (mirrorBar) {
      if (scrollY > collectionHeaderBottom) {
        if (!mirrorBar.classList.contains('is-visible')) {
          mirrorBar.classList.add('is-visible');
        }
      } else {
        if (mirrorBar.classList.contains('is-visible')) {
          mirrorBar.classList.remove('is-visible');
        }
      }
    }

    // Near top of page — always show header
    if (scrollY <= headerHeight) {
      header.classList.remove('j4k-header-hidden');
      isHidden = false;
      lastScrollY = scrollY;
      return;
    }

    // Scrolling down — hide header (navbar + mirror bar together)
    if (delta > SCROLL_THRESHOLD && !isHidden) {
      header.classList.add('j4k-header-hidden');
      isHidden = true;
      // Sidebar moves up — collection header at top:0 is ~60px tall
      if (sidebar) {
        sidebar.style.top = '70px';
        sidebar.style.maxHeight = 'calc(100vh - 70px)';
      }
    }

    // Scrolling up — show header (navbar + mirror bar together)
    if (delta < -SCROLL_THRESHOLD && isHidden) {
      header.classList.remove('j4k-header-hidden');
      isHidden = false;
      // Sidebar moves down — header is now visible (~140px total with mirror)
      if (sidebar) {
        var fullHeaderHeight = header.offsetHeight + 10;
        sidebar.style.top = fullHeaderHeight + 'px';
        sidebar.style.maxHeight = 'calc(100vh - ' + fullHeaderHeight + 'px)';
      }
    }

    lastScrollY = scrollY;
  }

  window.addEventListener('scroll', onScroll, { passive: true });
})();
